import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';
import type { BreakpointsKeys } from '@/theme/types';

import type { ContainerProps } from './Container';
export const Wrapper = styled(Box)<
  ContainerProps & { $maxWidth: BreakpointsKeys }
>`
  max-width: 100%;
  width: 100%;
  margin-inline: auto;
  ${({
    $maxWidth,
    disableGutters,
    disableGuttersDesktop,
    disableGuttersMobile,
    theme: { breakpoints, components, gridContainer, media, mediaQueries },
  }) => css`
    ${$maxWidth &&
    css`
      ${media[$maxWidth].up} {
        max-width: ${breakpoints[$maxWidth]};
      }
    `}
    ${!disableGutters &&
    css`
      ${!disableGuttersMobile &&
      css`
        padding-inline: ${gridContainer.xs};
        ${mediaQueries.sm} {
          padding-inline: ${gridContainer.sm};
        }
      `}
      ${!disableGuttersDesktop &&
      css`
        ${mediaQueries.md} {
          padding-inline: ${gridContainer.md};
        }
        ${mediaQueries.lg} {
          padding-inline: ${gridContainer.lg};
        }
        ${mediaQueries.xl} {
          padding-inline: ${gridContainer.xl};
        }
      `}
    `}

    ${components.container?.paddingInline &&
    css`
      ${media.md.down} {
        padding-inline: ${components.container.paddingInline};
      }
    `}
  `}
`;
